"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoJSPlayer = void 0;
var video_js_1 = __importDefault(require("video.js"));
require("video.js/dist/video-js.css");
var VideoJSPlayer = /** @class */ (function () {
    function VideoJSPlayer() {
        var _this = this;
        this.play = function () {
            var _a;
            (_a = _this.player) === null || _a === void 0 ? void 0 : _a.play();
        };
        this.pause = function () {
            var _a;
            (_a = _this.player) === null || _a === void 0 ? void 0 : _a.pause();
        };
        this.seekTo0 = function () {
            var _a;
            (_a = _this.player) === null || _a === void 0 ? void 0 : _a.currentTime(0);
        };
        this.load = function (src, type) {
            var _a;
            if (type === void 0) { type = 'video/mp4'; }
            (_a = _this.player) === null || _a === void 0 ? void 0 : _a.src([
                {
                    src: src,
                    type: type,
                },
            ]);
        };
        this.attachEvent = function (event, callback) {
            var _a;
            (_a = _this.player) === null || _a === void 0 ? void 0 : _a.on(event, callback);
        };
        this.detachEvent = function (event, callback) {
            var _a;
            (_a = _this.player) === null || _a === void 0 ? void 0 : _a.off(event, callback);
        };
        var video = document.createElement('video-js');
        video.setAttribute('style', "width: ".concat(window.innerWidth, "px; height: ").concat(window.innerHeight, "px"));
        var videoContainer = document.getElementById('video');
        videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer.appendChild(video);
        this.player = (0, video_js_1.default)(video, {
            controls: false,
            html5: {
                vhs: {
                    overrideNative: true,
                },
            },
        });
    }
    VideoJSPlayer.prototype.destroy = function () {
        var _a;
        (_a = this.player) === null || _a === void 0 ? void 0 : _a.dispose();
    };
    return VideoJSPlayer;
}());
exports.VideoJSPlayer = VideoJSPlayer;
